import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import Auth from './views/AuthorizationPage.vue'
import './registerServiceWorker'
import router from './router'
import authRouter from './router/authRouter'
import store from './store'
import i18n from './i18n'
import './assets/tailwind.css'

export const url = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' : 'https://oldoffice.profixone.com'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = document.location.origin

let session
document.cookie.split(';').forEach((el) => {
  // eslint-disable-next-line
  if (el.match(/X-XSRF-TOKEN/i)) session = el.split('=')[1]
})
if (session) {
  axios.get(`${url}/api/user`, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('tokenAuth')}`,
      Accept: 'application/json'
    }
  }).then((response) => {
    store.state.userInfo = response.data
    createApp(App).use(store).use(router).use(i18n)
      .mount('#app')
  }).catch(() => {
    createApp(App).use(store).use(router).use(i18n)
      .mount('#app')
  })
} else {
  createApp(Auth).use(store).use(authRouter).use(i18n)
    .mount('#auth')
}
